<template>
  <div class="xxhy-scrolling-box" ref="scrollingBox"></div>
</template>

<script>
export default {
  props: {
    lotteryRecord: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      count: 0
    };
  },
  mounted() {
    setTimeout(() => {
      this.scrolling();
    }, 500);
  },
  methods: {
    // 弹幕
    scrolling() {
      const info = this.lotteryRecord[this.count];
      if (!info) {
        return;
      }
      //创建标签
      const outWrap = document.createElement("div");
      const avatarEl = document.createElement("img");
      const contEl = document.createElement("div");

      // 填充数据
      avatarEl.src = info.user.touxiang;
      contEl.innerText = `${info.user.nickname} 获得了${info.prize_name}`;

      //将元素放入滚动区域
      outWrap.appendChild(avatarEl);
      outWrap.appendChild(contEl);
      this.$refs.scrollingBox.appendChild(outWrap);

      // 设置位置 和样式
      avatarEl.className = "scrolling-item-img";
      contEl.className = "scrolling-item-content";
      outWrap.style.top = this.count % 2 === 1 ? "10px" : "90px";
      const els = document.getElementsByClassName("scrolling-item");
      if (els.length > 1) {
        const width = getComputedStyle(els[els.length - 2]).width;
        const left = getComputedStyle(els[els.length - 2]).left;
        // outWrap.style.left = `calc(101vw + ${parseFloat(width) + 40}px)`;
        outWrap.style.left =
          parseFloat(width) + parseFloat(left) + 300 + "px";
      } else {
        outWrap.style.left = "101vw";
      }
      outWrap.className = "scrolling-item";
      setTimeout(() => {
        this.$refs.scrollingBox.removeChild(outWrap);
      }, 13000);

      setTimeout(() => {
        if (this.count === this.lotteryRecord.length - 1) {
          this.count = 0;
        } else {
          this.count++;
        }
        this.scrolling();
      }, Math.random() * 1000 + 1000);
    }
  }
};
</script>

<style lang="less">
@keyframes anim-scrolling {
  100% {
    left: -520px;
  }
}
// 弹幕区域
.xxhy-scrolling-box {
  height: 160px;
  width: 100%;
  position: relative;
  .scrolling-item {
    position: absolute;
    display: flex;
    align-items: center;
    animation-name: anim-scrolling;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    animation-duration: 12s;
    &-img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      border: 3px solid #F7F5F2;
    }
    &-content {
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
      line-height: 58px;
      margin-left: 10px;
      white-space: nowrap;
      height: 58px;
      padding: 0 20px;
      letter-spacing: 1px;
      border-radius: 4px;
      background: var(--primary, #FF5A1F);
    }
  }
}
</style>
